import { useQuery } from '@tanstack/react-query'
import useAuth from '@/features/auth/hooks/use-auth'
import { queryKeys } from '@/shared/constants/query-keys'
import { typePropertiesAdminV2Service } from '../services/type-properties-admin-v2.service'

/**
 * Subtipos activos (`{ id: typ_, code, name, project: prj_ }`) para los selects v2
 * que cascadean por proyecto —el form de inmuebles filtra por `project` en el
 * cliente—. Sólo corre con sesión staff v2; el catálogo casi no cambia, se cachea
 * largo.
 */
export const useTypePropertiesV2LookupQuery = () => {
  const { auth } = useAuth()
  const accessToken = auth?.v2AccessToken ?? ''
  return useQuery({
    queryKey: queryKeys.typeProperties.lookupV2(),
    queryFn: async () => await typePropertiesAdminV2Service.lookup(accessToken),
    enabled: Boolean(accessToken),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false
  })
}
